import { Grid } from '@domain-group/suit-theme'

import type { ImageModel } from '@models/types'

import Tile from './Tile'

type ImageGridContainerProps = {
  exportSizeErrorImageIds: number[],
  images: ImageModel[],
}

const ImageGridContainer = (props: ImageGridContainerProps) => {
  const { exportSizeErrorImageIds, images } = props

  return (
    <Grid
      // @ts-expect-error TS2322
      gridGap="medium"
      gridAutoRows="1fr"
      gridTemplateColumns="repeat(auto-fill, minmax(100px, 1fr))"
      gridTemplateRows="repeat(auto-fill, minmax(100px, 1fr))"
      padding="large"
    >
      {images.map(image => (
        <Tile
          exportSizeErrorImageIds={exportSizeErrorImageIds}
          image={image}
          key={image.id}
        />
      ))}
    </Grid>
  )
}

export default ImageGridContainer
